import BpkBreadcrumb, {
  BpkBreadcrumbItem,
} from '@skyscanner/backpack-web/bpk-component-breadcrumb';

import type { I18nService } from '@shared/types/i18n';
import type { FormatDate } from '@shared/types/i18n/localisation-service';
import type { EntityId, Nullable, Stay } from '@shared/types/utils';

import STYLES from './Breadcrumb.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';
import { getDayviewUrl } from '@shared/utils-frontend/url/url';

type Entity = {
  id?: Nullable<EntityId>;
  name?: string;
};

const generateUrl = ({
  dest,
  formatDate,
  stay,
}: {
  formatDate: FormatDate;
  dest?: Nullable<Entity>;
  stay: Stay;
}) => {
  if (!dest || !dest.id) {
    return undefined;
  }

  const destination = { entityId: dest.id };
  const url = getDayviewUrl({ destination, stay }, formatDate);

  return url;
};

type Props = {
  i18n: I18nService;
  city?: Nullable<Entity>;
  nation?: Nullable<Entity>;
  entity: {
    id: EntityId;
    name: string;
  };
  stay: Stay;
};
const Breadcrumb = ({
  city,
  entity,
  i18n: { formatDate, translate },
  nation,
  stay,
}: Props) => {
  const nationUrl = generateUrl({ dest: nation, stay, formatDate });
  const cityUrl = generateUrl({ dest: city, stay, formatDate });

  const routesMap = [
    {
      type: 'home',
      url: '/',
      name: translate('Explore_label_Home'),
      nofollow: false,
    },
    {
      type: 'hotels',
      url: '/hotels',
      name: translate('Footer_label_hotels'),
      nofollow: false,
    },
    {
      type: 'nation',
      url: nationUrl,
      name: nation?.name ?? '',
      nofollow: true,
    },
    { type: 'city', url: cityUrl, name: city?.name ?? '', nofollow: true },
    {
      type: 'entity',
      name: entity.name,
      nofollow: false,
    },
  ];

  const breadcrumbItems = routesMap.map(({ name, nofollow, type, url }) => {
    if (!name) {
      return null;
    }

    return (
      <BpkBreadcrumbItem
        key={type}
        href={url}
        className={!url ? STYLES.Breadcrumb__disabled : undefined}
        linkProps={nofollow ? { rel: 'nofollow' } : undefined}
        active={type === 'entity'}
      >
        {name}
      </BpkBreadcrumbItem>
    );
  });

  return (
    <BpkBreadcrumb className={STYLES.Breadcrumb} label="breadcrumb">
      {breadcrumbItems}
    </BpkBreadcrumb>
  );
};

export default withI18n(Breadcrumb);
